class BasicHelper {
  setParams (component) {
    this.component = component
  }

  /**
   * Returns TRUE, if date1 time haapened after d2
   * @param date1
   * @param date2
   * @returns {boolean}
   */
  isAfterTime (date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    if (d1.getTime() > d2.getTime()) {
      return true;
    }
    return false;
  }

  /**
   * Converts period code to object with period info. If period = 0, then it is year
   * @param periodCode
   * @returns {null|{period: number|null, year: number}}
   */
  datePeriodCodeToData (periodCode) {
    periodCode += '';
    if (periodCode && periodCode.length > 5) {
      return {
        year: parseInt(periodCode.substring(0, 4)),
        period: parseInt(periodCode.substring(5, 6))
      };
    }
    return null;
  }

  formatDatePeriod (periodCode, translateCode = 'general.datePeriod.short') {
    const codeData = this.datePeriodCodeToData(periodCode);
    if (codeData) {
      return this.component.$tc(translateCode, codeData.period, codeData);
    }
    return '';
  }

  /**
   * Get year by date period code
   * @param periodCode
   * @returns {null|number}
   */
  datePeriodCodeToYear (periodCode) {
    const periodData = this.datePeriodCodeToData(periodCode);
    if (periodData) {
      return periodData.year;
    }
    return null;
  }

  /**
   * Converts year to date period code, which is all year
   * @param string|number year
   * @returns {string}
   */
  yearToDatePeriod (year) {
    return year + '900';
  }

  /**
   * Calculates absolute difference
   * @param number val1
   * @param number val2
   * @returns {number}
   */
  getAbsDiff (val1, val2) {
    return Math.abs(val1 - val2);
  }

  /**
   * Calculates difference in periods between 2 periods
   * @param fromPeriodCode
   * @param toPeriodCode
   * @returns {number}
   */
  getDatePeriodDiff (fromPeriodCode, toPeriodCode) {
    const itemFrom = this.datePeriodCodeToData(fromPeriodCode);
    const itemTo = this.datePeriodCodeToData(toPeriodCode);
    if (itemFrom && itemTo) {
      return (itemTo.year - itemFrom.year) * 4 + (itemTo.period - itemFrom.period);
    }
    return 999;
  }

  /**
   * Get next date period code
   * @param periodCode
   * @returns {string}
   */
  getNextDatePeriod (periodCode) {
    const datePeriodConfig = (this.component.$store.getters.getItemsFromConfigWithFilter('datePeriodConfig'));
    const item = this.datePeriodCodeToData(periodCode);
    if (item) {
      if (item.period < datePeriodConfig.periodCount) {
        return item.year + '0' + (item.period + 1) + '0';
      }
      return (item.year + 1) + '010';
    }
    return '';
  }

  /**
   * Get previous date period code
   * @param periodCode
   * @returns {string}
   */
  getPreviousDatePeriod (periodCode) {
    const datePeriodConfig = (this.component.$store.getters.getItemsFromConfigWithFilter('datePeriodConfig'));
    const item = this.datePeriodCodeToData(periodCode);
    if (item) {
      if (item.period > 1) {
        return item.year + '0' + (item.period - 1) + '0';
      }
      return (item.year - 1) + '0' + datePeriodConfig.periodCount + '0';
    }
    return '';
  }

  getDatePeriodRangeFormatted (periodFrom, periodTo) {
    const periodDataFrom = this.datePeriodCodeToData(periodFrom);
    const periodDataTo = this.datePeriodCodeToData(periodTo);
    if (periodDataFrom && periodDataTo) {
      return this.component.$tc('general.datePeriod.short', periodDataFrom.period, periodDataFrom) + ' - ' +
        this.component.$tc('general.datePeriod.short', periodDataTo.period, periodDataTo);
    }
    return '';
  }

  cloneObject (object) {
    return JSON.parse(JSON.stringify(object));
  }

  /**
   * Store in session filters used for specifc page
   * @param page
   * @param filterValues
   */
  updateFilterValues (page, filterValues) {
    this.component.$session.set('filters:' + page, filterValues);
  }

  /**
   * Load last filters values from session and fill current filter values with them
   * @param string page
   * @param object filterValues
   * @returns {object}
   */
  fillFilterValues (page, filterValues) {
    const curFilters = this.cloneObject(filterValues);
    if (this.component.$session) {
      const sessionFilter = this.component.$session.get('filters:' + page);
      if (sessionFilter) {
        for (const [key, value] of Object.entries(sessionFilter)) {
          curFilters[key] = value;
        }
      }
    }
    return curFilters;
  }

  /**
   * Get selected client apiId for user (user might have access to multiple clients)
   * @returns {string}
   */
  getUserClientApiId () {
    let clientApiId = this.component.$session.get('selectedClientApiId');
    const clientPermissions = this.component.$session.get('client_permissions');
    if (!clientPermissions) {
      return null;
    }
    if (!clientApiId || !clientPermissions[clientApiId]) {
      clientApiId = Object.keys(clientPermissions)[0];
      this.component.$session.set('selectedClientApiId', clientApiId);
    }
    return clientApiId;
  }

  /**
   * Get name of selected client
   * @returns {null|*}
   */
  getUserClientName () {
    const apiId = this.getUserClientApiId();
    if (apiId) {
      const perms = this.component.$session.get('client_permissions');
      if (perms && perms[apiId]) {
        return perms[apiId].name;
      }
    }
    return null;
  }

  /**
   * Check if selected user client is blocked
   * @returns boolean
   */
  isUserClientBlocked () {
    const apiId = this.getUserClientApiId();
    if (apiId) {
      const perms = this.component.$session.get('client_permissions');
      if (perms && perms[apiId]) {
        return (perms[apiId].isAxBlocked || perms[apiId].isBlocked);
      }
    }
    return false;
  }

  /**
   * Get basic translation or default if not set
   * @param item
   * @returns {null|*}
   */
  getTranslation (item) {
    if (item) {
      if (item[this.component.$i18n.locale]) {
        return item[this.component.$i18n.locale];
      } else if (item[this.component.$i18n.fallbackLocale]) {
        return item[this.component.$i18n.fallbackLocale];
      }
    }
    return null;
  }

  /**
   * Find element by string key, f.e, 'client.name'
   *
   * @param Object baseEl
   * @param String keyStr
   * @returns {Object|null|String}
   */
  getObjectValueByString (baseEl, keyStr) {
    let el = baseEl;
    const keys = keyStr.split('.');
    for (const idx in keys) {
      el = el[keys[idx]];
      if (el === null || typeof el === 'undefined') {
        return null;
      }
    }
    return el;
  }

  /**
   * Create .xls report
   * Could be improved to split tables between spreadsheets + correct .xls file (now when opening there is warning)
   *
   * @param Object tableHTMLs
   * @param string filename
   */
  tablesToExcelFile (tableHTMLs, filename = '') {
    const uri = 'data:application/vnd.ms-excel,';
    filename = filename ? filename + '.xls' : 'excel_data.xls';
    let fileData = '<meta charset="UTF-8" />';
    for (const el of Object.values(tableHTMLs)) {
      fileData += el.replace('<table', '<table border="1"').replaceAll(/&nbsp;/g, '');
    }

    const downloadLink = document.createElement('a');
    downloadLink.href = uri + encodeURIComponent(fileData);
    downloadLink.download = filename;
    downloadLink.click();
  }

  /**
   * Sort array by value of each elements specific key
   * @param array
   * @param keyName
   * @returns {array}
   */
  sortArrayByKeyValue (array, keyName, sortDesc = false) {
    const tmpEls = this.cloneObject(array)
    tmpEls.sort(function (a, b) {
      if (sortDesc) {
        return (a[keyName] < b[keyName]) - (a[keyName] > b[keyName]);
      }
      return (a[keyName] > b[keyName]) - (a[keyName] < b[keyName]);
    });
    return tmpEls;
  }

  yesNoOptions (reverse = false) {
    if (reverse) {
      return [
        { code: '1', value: 1, text: this.component.$t('general.no') },
        { code: '0', value: 0, text: this.component.$t('general.yes') }
      ];
    }
    return [
      { code: '0', value: 0, text: this.component.$t('general.no') },
      { code: '1', value: 1, text: this.component.$t('general.yes') }
    ];
  }

  getConfigValueById (configKey, id, param, translate = true) {
    const item = this.component.$store.getters.getDataFromConfigById(configKey, id);
    if (item && item[param]) {
      if (translate) {
        return this.getTranslation(item[param]);
      }
      return item[param];
    }
    return null;
  }

  getConfigValue (configKey, filterKey, filterValue, param, translate = true) {
    const item = this.component.$store.getters.getDataFromConfigWithFilter(configKey, filterKey, filterValue);
    if (item) {
      return this.getConfigValueText(item, param, translate, this.component.$i18n.locale, this.component.$i18n.fallbackLocale);
    }
    return '';
  }

  /** Generate config value text by provided configParams and translate them if needed **/
  getConfigValueText (el, configParam, translate = true, lang = null, defaultLang = null) {
    if (!Array.isArray(configParam)) {
      configParam = [configParam];
    }
    const res = [];
    configParam.forEach((param, index) => {
      res[index] = null;
      if (param && el[param]) {
        res[index] = el[param];
      }
      if (translate && lang && res[index]) {
        if (res[index][lang] && res[index][lang] !== '') {
          res[index] = res[index][lang];
        } else if (res[index][defaultLang]) {
          res[index] = res[index][defaultLang];
        } else {
          res[index] = null;
        }
      }
    });
    let resStr = res.shift();
    if (res.length > 0) {
      resStr += ' [' + res.join(', ') + ']';
    }
    return resStr;
  }

  openRouteUrl (routeName = null, routeParams = null, href = '', newtab = false) {
    if (routeName) {
      href = this.component.$router.resolve({ name: routeName, params: routeParams }).href;
    }
    if (href) {
      if (newtab) {
        window.open(href, '_blank');
      } else {
        this.component.$router.push(href);
      }
    }
  }
}
export default new BasicHelper()
